import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { visaAppliedAction } from "../../store/VisaApplied/VisaAppliedReducer";
import { visaAppliedUpdateDeliveryDate } from "../../store/VisaApplied/VisaAppliedAction";
import { useDispatch, useSelector } from "react-redux";
import {toast} from "react-toastify";
import Loading from "../../components/Loading";

const AppliedVisa = ({ visaApplication }) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const { visaAppliedUpdateLoading, visaAppliedUpdateError, visaAppliedUpdateSuccess } = useSelector((state) => state.visaApplied);
  const dispatch = useDispatch();
  const [updatingId, setUpdatingId] = useState(null); // track the clicked card


  const {
    visaImage,
    heading,
    deliveryDate,
    numTravellers,
    status,
    createdBy,
    fairValue,
    travellers,
    deliverDays,
    departureDate,
    _id,
  } = visaApplication;

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }

  const formatGetDate = (date) => {
  const options = {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  };
  return date.toLocaleDateString("en-US", options);
};

const getDate = (deliverDays) => {
  const currentDate = new Date();
  let remainingDays = parseInt(deliverDays, 10);
  let deliveryDate = new Date(currentDate);

  // Loop until all deliverable days are counted
  while (remainingDays > 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1); // Move to the next day

    // Check if the day is not Saturday (6) or Sunday (0)
    if (deliveryDate.getDay() !== 6 && deliveryDate.getDay() !== 0) {
      remainingDays--; // Only count weekdays
    }
  }
  return deliveryDate;
};

  const statusSteps = ["Ongoing", "Verification", "Processing", "Finished"];

  let displaySteps = [...statusSteps];
  let failIndex = -1;

  if (status === "Verification Failed") {
    displaySteps[1] = "Verification Failed";
    failIndex = 1;
  } else if (status === "Processing Failed") {
    displaySteps[2] = "Processing Failed";
    failIndex = 2;
  }

  const currentStatusIndex = failIndex !== -1 ? failIndex : statusSteps.indexOf(status);


  useEffect(() => {
    if (visaAppliedUpdateError) {
      toast.error("Failed to get payment page. Please try again in sometime.");
      dispatch(visaAppliedAction.clearVisaAppliedUpdateError());
    }
    if (visaAppliedUpdateSuccess && updatingId === _id) {
      navigate(`/payment/${_id}`);

      dispatch(visaAppliedAction.clearVisaAppliedUpdateSuccess());
    }
  }, [visaAppliedUpdateError, visaAppliedUpdateSuccess, dispatch, navigate, _id, updatingId]);

  
  const handlePaymentClick = () => {
    setUpdatingId(_id);
    dispatch(visaAppliedUpdateDeliveryDate({ id: _id, deliveryDate: formatGetDate(getDate(deliverDays)) }));
  };

  return (<> {visaAppliedUpdateLoading ? <Loading></Loading> :
    <div className="visa-applied-card">
      <div className="visa-applied-card__header">
        <img src={visaImage} alt={heading} className="visa-applied-card__image" />
        <div className="visa-applied-card__info">
          <h2>{heading}</h2>
          <div className="visa-applied-card-details-container">
            <div className="visa-applied-card__dates">
              <div>
                <p><strong>Applied</strong></p>
                <p>{formatDate(new Date(createdBy))}</p>
              </div>
              <div>
                <p><strong>Total Travellers:</strong> {numTravellers}</p>
                <p><strong>Status:</strong> {status}</p>
              </div>
            </div>
            <div className="visaApplied-airplane-icon-container">
              <div className="visaApplied-airplane-icon">
                <img
                  width={"35px"}
                  height={"35px"}
                  alt="airplane icon"
                  src="/airplane.svg"
                />
              </div>
            </div>
            <div className="visa-applied-card__details">
              <div>
                <p><strong>Estimated Delivery</strong></p>
                <p>{status === "Payment Pending" ? formatGetDate(getDate(deliverDays)): deliveryDate}</p>
              </div>
              <div>
                {status === "Payment Pending" ? getDate(deliverDays) < new Date(departureDate) ? (
                  <div className="visa-applied-card__payment">
                    <button onClick={handlePaymentClick}>Complete Payment</button>
                  </div>
                ) : <div style={{"color":"red", "fontSize":"1.6rem", "marginTop":"1rem"}}>Expired</div>:
                  <p>
                    <strong>Paid:</strong> {fairValue.currency === "INR" ? "₹" : "$"}
                    {fairValue.grandTotal}
                  </p>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {status !== "Payment Pending" && (
        <div className="visa-applied-card__line-tracker">
          {displaySteps.map((step, index) => {
            const isLast = index === displaySteps.length - 1;
            const isActive = index <= currentStatusIndex;
            const isFailedDot = index === failIndex && failIndex !== -1;

            // Decide line color between dots
            let lineColor = "gray";
            if (failIndex !== -1 && index === failIndex-1) {
              lineColor = "red";
            } else if ( index < currentStatusIndex) {
              lineColor = "green";
            }

            return (
              <div key={index} className="line-step">
                <div className={`dot ${isFailedDot ? "red" : isActive ? "green" : ""}`}></div>
                {!isLast && <div className={`step-line ${lineColor}`}></div>}
                <span>{step}</span>
              </div>
            );
          })}
        </div>
      )}

      <div className="visa-applied-card__expand" onClick={() => setExpanded(!expanded)}>
        {expanded ? <><FaChevronUp /> Hide Travellers Details</> : <><FaChevronDown /> Show Travellers Details</>}
      </div>

      {expanded && (
        <div className="visa-applied-card__travelers">
          {travellers.map((t, i) => (
            <div className="traveler" key={i}>
              <div className="traveler__details">
                <h4>
                  {t.passport.firstName} {t.passport.lastName}
                </h4>
                <p><strong>Passport Number:</strong> {t.passport.passportNumber}</p>
                <p><strong>Date of Birth:</strong> {t.passport.birthDate}</p>
                <p><strong>Gender:</strong> {t.passport.sex}</p>
              </div>
              <div className="traveler__docs">
                <img src={t.passport.frontImage} alt="Passport Front" />
                <img src={t.passport.backImage} alt="Passport Back" />
                <img src={t.photo.image} alt="Traveller" />
                {t.usVisa?.image && <img src={t.usVisa.image} alt="US Visa" />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
 } </>
  );
};

export default AppliedVisa;